import { Box, Button, Divider, Flex, Text, Textarea, Tooltip } from "@mantine/core";
import { useContext, useEffect, useState } from "react";
import DiscoveryContext from "./DiscoveryContext";
import { IconArrowRight, IconX } from "@tabler/icons";
import { ConvertIcon } from "../../icons/x-symbol-svgrepo-com";
import { formatDate, getBagelId, getConnectedUserRole } from "../../utils";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { createNewIdea, saveIdea } from "../../Api";
import { truncateText } from "../../utils";
import SyncContext from "../../context/SyncContext";
import FiltersContext from "../ideas/filters/context/FiltersContext";

const DiscoveryTextArea = ({
  setNewIdeaFormView,
  urlIdeaId
}: {
  setNewIdeaFormView: React.Dispatch<React.SetStateAction<boolean>>;
  urlIdeaId?: string | null
}) => {


  const { defaultStatus , defaultPriority } = useContext(SyncContext)

  const { setActiveFilters } = useContext(FiltersContext)

  const {
    ideaId,
    idea,
    setIdea,
    setIdeaId,
    setRevalidate,
    fetchDiscoveryIdea,
    fetchRecentQueries,
    recentQueries,
    setLoadingIdeasMatches,
    setLoadingEvidenceMatches,
    setQueryLoader,
    revalidate,
    loadIdeaMatches,
    setLoadingMatches,
    setComputed,
    loadingMatches,
    setMatchesTrigger
    
  } = useContext(DiscoveryContext);



  const createIdeaDiscovery = (text: string)=>{

    setActiveFilters([])
    setComputed(false) 
    setIdeaId(null) 
    setLoadingIdeasMatches(true)
    setLoadingEvidenceMatches(true)
    setQueryLoader(false);
    if(!loadingMatches){
      setLoadingMatches(true)
    }
    const newObj = { idea:
      
      { title: '',
        description: text,
        ownerId: getBagelId(auth0.user),
        status: defaultStatus,
        priority: defaultPriority,
        state: 'draft'}
    };

    createNewIdea(newObj, auth0)
      .then((response) => {
        const newId = response?.idea?._id;
        setIdea(response?.idea)
        if (newId) {
          setIdeaId(newId)
          setMatchesTrigger(1) 
          loadIdeaMatches(text)
        } else {
          console.log(`did not receive request id for new idea`, response);
        }
      })
      .catch(console.log)
  }

  const [description, setDescription] = useState<any>('');
  const [isValidated, setIsValidated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (idea) {
      setIsValidated(idea.description === description && !revalidate);
    }
  }, [idea, description, revalidate]);

  useEffect(() => {
    if (urlIdeaId) {
      console.log({fetchDiscoveryIdea:urlIdeaId})
      fetchDiscoveryIdea(urlIdeaId);
    }
  }, []);

  useEffect(() => {
    fetchRecentQueries()
  },[])

  useEffect(() => {
    if (ideaId) {
      navigate(`/discovery?ideaId=${ideaId}`, { replace: true });
    }
  }, [ideaId]);
  
  const handleRecentQueryClick = (query: any) => {
    saveIdea({ id: query._id, updatedAt : true}, auth0)
      .then(()=>{
        fetchRecentQueries()
        loadIdeaMatches(query.description)
      })
    setIdea(query);
    setIdeaId(query._id)
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    const oneMonthAgoISO = oneMonthAgo.toISOString();
    if (query.createdAt < oneMonthAgoISO) {
      setRevalidate(true);
    } else {
      setRevalidate(false);
    }
    navigate(`/discovery?ideaId=${query._id}`, { replace: true });
    setDescription(query.description)
    if (ideaId !== query._id) {
      setLoadingIdeasMatches(true);
      setLoadingEvidenceMatches(true);
      setQueryLoader(true);
    }
  }
 
  const auth0 = useAuth0();
  const role = getConnectedUserRole(auth0);
  const canConvert = role === "manager" || role === "admin";
  return (
    <Box
      bg="rgba(92, 92, 235, 0.1)"
      sx={{ borderRight: "1px solid #D8D8DB",  minHeight: `calc(100vh - 115px)` , height: "100%"}}
      py={24}
      px={36}
    >
      <Box sx={{
        // position: "sticky",
        // top: "25px",
      }}>
        <Text fz={18} fw={600} mb={8}>
        What is the Product Idea?
        </Text>
        <Text fz={12} fw={400}>
        Describe the
          <span style={{ fontWeight: 600 }}> desired product capability </span> in
        1-2 sentences.
        </Text>
        <Text mb={24} fz={12} fw={400}>
        Add the underlying
          <span style={{ fontWeight: 600 }}> need or pain point </span> it solves
        for the customer.
        </Text>
      
        <Textarea
          sx={{ borderRadius: 8 }}
          minRows={5}
          mb={16}
          value={description}
          onChange={(event) => setDescription(event.currentTarget.value)}
        />
        <Box w='100%'>
          <Flex justify="space-between">
            <Button 
              disabled={description.length == 0 }
              styles={(theme) => ({
                root: {
                  height: "32px",
                  backgroundColor: "#5C5CEB1A",
                  color: "#5C5CEB",
                  border: 0,
                  fontWeight: 400,
                  padding: 0,
                  "&:hover": {
                    backgroundColor: "#5C5CEB1A",
                    color: "#5C5CEB", 
                  },
                  "&:disabled": {
                    backgroundColor: "#D8D8DB", 
                    color: "#ffffff", 
                    cursor: "not-allowed",
                    opacity: 1, 
                  },
                },
              })}
              px={8}
              leftIcon={description.length == 0  ? <IconX size={12} color='#ffffff'/> : <IconX size={12} color='#5C5CEB'/>}
              onClick={()=> setDescription('')}
            >
              <Text fz="12px">Clear text</Text>
            </Button> 
            <Flex gap={10}>
              {canConvert && (
                <Button
                  disabled={description.length < 4 || !ideaId || !isValidated}
                  w={130}
                  styles={(theme) => ({
                    root: {
                      height: "32px",
                      backgroundColor: "#5C5CEB1A",
                      color: "#5C5CEB",
                      border: 0,
                      fontWeight: 400,
                      padding: 0,
                      "&:hover": {
                        backgroundColor: "#5C5CEB1A",
                        color: "#5C5CEB", 
                      },
                      "&:disabled": {
                        backgroundColor: "#D8D8DB", 
                        color: "#ffffff", 
                        cursor: "not-allowed",
                        opacity: 1, 
                      },
                    },
                  })}
                  leftIcon={description.length < 4 || !ideaId || !isValidated ? <ConvertIcon color="#ffffff" /> : <ConvertIcon />}
                  onClick={() => {
                    setNewIdeaFormView(true);
                  }}
                >
                  <Text fz={12}>
                Convert to idea
                  </Text>
                </Button>
              )}
              <Box style={{ position: 'relative' }}>
                {revalidate && (
                  <Tooltip label={`Last updated at ${formatDate(idea?.createdAt)}`}>
                    <Box
                      style={{
                        position: 'absolute',
                        top: -3,
                        right: -3,
                        width: 8,
                        height: 8,
                        backgroundColor: '#FF4D4F',
                        borderRadius: '50%',
                        zIndex: 2
                      }}
                    />
                  </Tooltip>
                )}
                <Button
                  w={90}
                  disabled={description.length < 4 || isValidated}
                  styles={(theme) => ({
                    root: {
                      height: "32px",
                      backgroundColor: "#5C5CEB",
                      border: 0,
                      fontWeight: 400,
                      padding: 0,
                      "&:hover": {
                        backgroundColor: theme.fn.darken("#5C5CEB", 0.05),
                      },
                      "&:disabled": {
                        backgroundColor: "#D8D8DB", 
                        color: "#ffffff", 
                        cursor: "not-allowed",
                        opacity: 1, 
                      },
                    },
                  })}
                  leftIcon={<IconArrowRight color="#ffffff" size={14} />}
                  onClick={() => {
                    createIdeaDiscovery(description)
                  }}
                >
                  <Text  color="#ffffff" fz={12}>{revalidate ? "Revalidate" : "Validate"}</Text>
                </Button>
              </Box>
            </Flex>
          </Flex>
        </Box>
      </Box>
      <Divider my={20} w={"100%"} />
      <Box>
        <Text fz={18} fw={600} color="#212529" mb={15}>Recent queries</Text>
        {recentQueries?.map((query:any) => (
          <Tooltip 
            label={
              (query.description)?.charAt(0).toUpperCase() +
              (query.description)?.slice(1)
            } 
            withArrow>
            <Box 
              sx={{
                backgroundColor: ideaId === query._id ? "#5C5CEB33" : "#5C5CEB1A",
                border: ideaId === query._id ? "1px solid #5C5CEB" : "none",
                borderRadius: "4px",
                padding: "8px",
                cursor: "pointer",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                "&::first-letter": {
                  textTransform: "uppercase"
                }
              }}
              color="#212529"
              my={10}
              fz={12} 
              onClick={() => handleRecentQueryClick(query)}
            >
              {truncateText(query.description, 80)}
            </Box>
          </Tooltip>
        ))}
      </Box>
    </Box>
  );
};

export default DiscoveryTextArea;
